import type { GroupedItems } from '@/app/(pages)/results/api/queries';
import type { CriteoOneTagEvent } from '@weberus/client-tracker';
import type { GlobalAccommodationCheckIOCapacity } from '../../../_shared/store/global-accommodation';

interface CreateCriteoLogPayload {
  memberId?: string;
  category?: string;
  checkInDate?: string;
  checkOutDate?: string;
  capacityAdults: number;
  childrenAges: number[];
  globalCheckIOCapacity?: GlobalAccommodationCheckIOCapacity;
  keyword?: string;
  filteredList: GroupedItems[];
}

export const buildCriteoLogPayload = ({
  memberId,
  category,
  checkInDate,
  checkOutDate,
  capacityAdults,
  childrenAges,
  globalCheckIOCapacity,
  keyword,
  filteredList,
}: CreateCriteoLogPayload): CriteoOneTagEvent[] => {
  let checkinDate = '';
  let checkoutDate = '';
  let nbra = 0;
  let nbrc = 0;

  if (category === 'LOCAL_ACCOMMODATION') {
    checkinDate = checkInDate || '';
    checkoutDate = checkOutDate || '';
    nbra = capacityAdults;
    nbrc = childrenAges.length;
  }
  if (category === 'GLOBAL_ACCOMMODATION' && globalCheckIOCapacity) {
    const { checkInDate, checkOutDate, capacityRooms } = globalCheckIOCapacity;

    checkinDate = checkInDate || '';
    checkoutDate = checkOutDate || '';
    nbra = capacityRooms.reduce((acc, room) => acc + room.adult, 0);
    nbrc = capacityRooms.reduce((acc, room) => acc + room.child.length, 0);
  }

  const item = getCriteoViewListItems(filteredList, 3);
  return [
    {
      event: 'setEmail',
      email: memberId || '',
      hash_method: memberId ? 'md5' : '',
    },
    { event: 'setZipcode', zipcode: '' },
    {
      event: 'viewSearch',
      checkin_date: checkinDate,
      checkout_date: checkoutDate,
      nbra,
      nbrc,
      nbri: 0,
    },
    { event: 'viewList', category: '', item, keywords: keyword || '' },
  ];
};

const getCriteoViewListItems = (filteredList: GroupedItems[], limit: number) => {
  if (!filteredList || filteredList.length === 0) {
    return [];
  }
  // filteredList에서 상품 타입의 아이템을 추출
  const flatItems = filteredList.flatMap((groupItem) => (Array.isArray(groupItem) ? groupItem : []));
  return flatItems
    .filter((item) => item.type === 'PRODUCT_ITEM' || item.type === 'BANNER_TYPE_PRODUCT_ITEM')
    .map((item) => item.data.id)
    .slice(0, limit);
};
